var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.vComponentName,{tag:"component",class:['app-nav-item', { active: _vm.vActive }],attrs:{"to":_vm.vTo,"href":_vm.vHref}},[_c('ui-flex',{attrs:{"row":"","between":""}},[_c('ui-flex',[_vm._t("default")],2),_c('ui-flex',{attrs:{"zero":""}},[_vm._t("right")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }